/*
 * -----------------------------------------------------------------------
 *  <copyright file="tab-heading/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { Checkbox } from '@progress/kendo-react-inputs';
import React from 'react';
import { TabHeadingProps } from '@components/admin/studies/study-settings-dialogs/edit-overview-tables/tab-heading/tab-heading.interface';
import HeadingActions from '@components/core/heading-actions';
import { useTranslation } from '@hooks/index';
import './styles.scss';

const TabHeading = ({ id, displayValue, setDisplay, actions }: TabHeadingProps) => {
    const { t } = useTranslation();

    return (
        <div className="tab-heading k-d-flex k-justify-content-between" key={id}>
            <Checkbox
                rounded={null}
                id={id}
                className="cell-checkbox no-border"
                checked={displayValue}
                onChange={setDisplay}
                label={t('admin:displayOnStudySummary')}
                data-testid={`${id}-checkbox`}
                size="medium"
            />
            <HeadingActions items={actions} />
        </div>
    );
};

export default TabHeading;
